Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing,
    fontSize = _STYLES$useStyles.fontSize,
    lineHeight = _STYLES$useStyles.lineHeight,
    grid = _STYLES$useStyles.grid,
    COLORS = _STYLES$useStyles.COLORS,
    fontSemiBold = _STYLES$useStyles.fontSemiBold;
  var heading = {
    textAlign: 'center',
    fontSize: fontSize.normal,
    lineHeight: lineHeight.normal,
    marginBottom: spacing.l
  };
  if (bp.is([bp.tablet, bp.desktop])) {
    heading.fontSize = fontSize.l;
    heading.lineHeight = lineHeight.l;
  }
  var text = Object.assign({}, fontSemiBold, {
    fontSize: fontSize.s,
    lineHeight: lineHeight.s,
    color: COLORS.aubergine
  });
  if (bp.is([bp.tablet, bp.desktop])) {
    text.fontSize = fontSize.normal;
    text.lineHeight = lineHeight.normal;
  }
  var styles = _reactNative.StyleSheet.create({
    container: {
      maxWidth: grid.maxCardWidth,
      width: '100%',
      alignSelf: 'center',
      alignItems: 'center'
    },
    heading: heading,
    textContainer: {
      textAlign: 'center',
      marginBottom: spacing.l
    },
    text: text
  });
  return {
    styles: styles
  };
};